import mobileAdjustment from "../GeneralMobileAdjustments";

class MobileSubmitButtonControlView {

    constructor() {}

    afterRender(control) {
        let element = mobileAdjustment.adjustMobileControl(control);
        mobileAdjustment.setButtonsHeight(element);
    }
}

const mobileSubmitButtonControlView = new MobileSubmitButtonControlView();
export default mobileSubmitButtonControlView;